import { SkeletonOptions, Stack } from '@chakra-ui/react';
import { Color } from '@shinetools/sunshine';
import { Typography } from '@shinetools/sunshine-universal';

import SunshineCard from 'components/_core/SunshineCard';
import Skeleton from 'components/Skeleton';
import SkeletonCircle from 'components/SkeletonCircle';

import locales from './locales';

const SKELETON_PROPS: {
  startColor: Color;
  endColor: Color;
  speed: SkeletonOptions['speed'];
} = {
  endColor: 'grey.400',
  speed: 1.5,
  startColor: 'grey.200',
};

export const ItemSkeleton = () => (
  <SunshineCard>
    <Stack gap="space-4">
      <Skeleton {...SKELETON_PROPS} width="60%">
        {locales.loading}
      </Skeleton>

      <Skeleton {...SKELETON_PROPS} width="45%">
        <Typography.Text size="small" variant="secondary">
          {locales.loading}
        </Typography.Text>
      </Skeleton>
    </Stack>

    <SunshineCard.Slot name="action">
      <SkeletonCircle {...SKELETON_PROPS} />
    </SunshineCard.Slot>
  </SunshineCard>
);
